import styled from 'styled-components';
import { SEMANTIC_COLORS } from '@/constant/unit/color';
export const S = {
    Layout: styled.div `
    display: flex;
    flex-direction: column;
    flex: 1;

    width: 100%;
    padding: 30px 30px 40px;
  `,
    FeedbackError: styled.div `
    margin: 2px 0;
    font-size: 16px;
    line-height: 23px;
    color: ${SEMANTIC_COLORS.ERROR_TEXT};
  `,
    LayoutFooter: styled.div `
    display: flex;
    justify-content: center;

    width: 100%;
    padding: 30px 0 40px;
  `,
    GapRow: styled.div `
    width: ${(props) => `${props.width}px`};
  `,
};
